import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { Placement } from 'common/components/tooltip/types';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { AddReportButtonTheme } from './constants';
export function template() {
  const theme = this.attr("theme");
  let extraAttrs = {};

  if (theme === AddReportButtonTheme.Header) {
    extraAttrs = {
      disabled: this.attr("disabled"),
      icon: {
        leftIcon: "plus"
      },
      'never-show-caret': true,
      'selected-option': "Report",
      theme: ButtonTheme.Primary
    };
  }

  return jsx("div", null, jsx(SelectEl, {
    attrs: Object.assign({
      sections: this.helpers.getReportSections(),
      'menu-width': 168
    }, extraAttrs),
    on: {
      change: this.helpers.handleCreateReportClicked,
      menuChange: this.helpers.handleCreateReportSelectClicked
    }
  }, theme === AddReportButtonTheme.Sidenav ? jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      slot: "trigger",
      icon: "plus",
      disabled: this.attr("disabled")
    },
    sel: '.sidenav.expanded'
  }, "Create New") : theme === AddReportButtonTheme.CollapsedSidenav ? jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      slot: "trigger",
      icon: "plus",
      disabled: this.attr("disabled")
    },
    sel: '.sidenav.collapsed'
  }) : null), this.attr("tooltip") && jsx(TooltipEl, {
    attrs: {
      text: this.attr("tooltip"),
      placement: Placement.Top
    }
  }));
}